<template>
  <div style="height: 100%">
    <div class="sa-flexbox" style="padding-bottom: 20px">
      <div class="sa-flexbox-body">
        <div class="b-table-sticky-header">
          <span class="sa-flexbox-body-title">Obiettivi Attivita</span>
          <b-button size="sm" variant="outline-success outline-primary-noborder sa-margin-right float-sm-right" @click="onClickNuovoObbiettivo" class="mb-2">
            <font-awesome-icon icon="plus"> </font-awesome-icon>
            Aggiungi
          </b-button>
          <b-table sticky-header ref="table" stacked="lg" striped hover :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage" :key="listKey" sort-icon-left head-variant="light" class="sa-b-table">
            <template #cell(index)="row">
              {{ row.index + 1 }}
            </template>
            <template #cell(actions)="row">
              <b-container class="bv-example-row">
                <b-button size="sm" variant="btn btn-outline-primary waves-effect waves-light width-sm no-text" style="margin-right: 5px" @click="onModificaObiettivo(row)">
                  <b-icon icon="pencil"></b-icon>
                </b-button>
                <b-button size="sm" variant="btn btn-outline-danger waves-effect waves-light width-sm no-text" style="margin-right: 5px" @click="onEliminaObiettivo(row)">
                  <b-icon icon="trash"></b-icon>
                </b-button>
              </b-container>
            </template>
          </b-table>
        </div>
      </div>
      <div class="sa-list-component-footer">
        <rsa-paziente-attivita-obiettivi-modal-component @reload="onReloadData" ref="cmpRsaPazienteAttivitaObiettiviModalComponent"></rsa-paziente-attivita-obiettivi-modal-component>
        <b-row class="sa-label-info" style="margin-left: 0.5rem; margin-right: 0.5rem">
          <b-col lg="3">
            <p>Record Totali:{{ rows }}</p>
          </b-col>
          <b-col lg="9">
            <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage" align="right" size="sm"></b-pagination>
          </b-col>
        </b-row>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import UtilityMixin from "../../../utility/UtilityMixin";
import RsaPazienteAttivitaObiettiviModalComponent from "./RsaPazienteAttivitaObiettiviModalComponent.vue";
export default {
  components: { RsaPazienteAttivitaObiettiviModalComponent },
  mixins: [UtilityMixin],
  data() {
    return {
      rows: 0,
      perPage: 50,
      currentPage: 1,
      pathResources: "/rsaattivitapazienteobiettivo",
      listKey: 0,
      items: [],
      idAccettazione: "",
      fields: [
        { key: "index", label: "", thStyle: "width: 2rem" },
        { key: "nomeAttivita", label: "Attivita" },
        { key: "obiettivo", label: "Obiettivo" },
        { key: "periodo", label: "Periodo" },
        {
          key: "dataInizio",
          label: "Data Inizio",
          formatter: (value) => {
            if (!value) {
              return "";
            } else {
              return moment(new Date(value)).format("DD-MM-YYYY");
            }
          },
        },
        {
          key: "dataFine",
          label: "Data Fine",
          formatter: (value) => {
            if (!value) {
              return "";
            } else {
              return moment(new Date(value)).format("DD-MM-YYYY");
            }
          },
        },

        // { key: "descrizione", label: "Descrizione", thStyle: "heigth: 10rem" },
        { key: "actions", label: "", class: "sa-table-column-action-double" },
      ],
    };
  },
  mounted() {
    console.log(this.$route);
    this.idAccettazione = this.$route.query.idAccettazione;
    this.loadData();
  },
  methods: {
    loadData() {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResources, { idAccettazione: me.idAccettazione }, me.loadDataSuccess, me.loadDataError);
    },
    loadDataSuccess(response) {
      let me = this;
      me.items = response.data.data.list;
      me.rows = response.data.rows;
      me.listKey++;
    },
    loadDataError(error) {
      console.error("Errore nel caricamento dei dati:", error);
    },
    onClickNuovoObbiettivo() {
      this.$refs.cmpRsaPazienteAttivitaObiettiviModalComponent.show();
    },
    onModificaObiettivo(row) {
      this.$refs.cmpRsaPazienteAttivitaObiettiviModalComponent.show(row.item);
    },
    onReloadData() {
      this.loadData();
    },
    onEliminaObiettivo(row) {
      let me = this;
      this.$bvModal
        .msgBoxConfirm("Sicuro di voler procedere alla cancellazione ?", {
          title: "Titolo",
          buttonSize: "sm",
          okVariant: "secondary",
          cancelVariant: "danger",
          okTitle: "SI",
          cancelTitle: "NO",
          footerClass: "p-2",
          hideHeaderClose: false,
          centered: true,
        })
        .then((value) => {
          if (value) {
            let link = process.env.VUE_APP_PATH_API + me.pathResources + "/" + row.item.id;
            UtilityMixin.methods.restCallDelete(link, me.deleteSuccess, me.deleteError);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    deleteSuccess(response) {
      let me = this;
      me.$bvToast.toast(response.data.messaggio, {
        title: "",
        variant: "success",
        solid: true,
      });
      this.loadData();
    },
    deleteError(error) {
      error;
    },
  },
};
</script>

<style lang="scss" scoped></style>
